import React from 'react';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import Field from '../../utils/Field';
import HttpClient from '../../utils/HttpClient';
import style from './MetadataForm.module.css';

export default class MetadataForm extends React.Component {

  httpClient = new HttpClient();

  constructor(props) {
    super(props);
    this.field = new Field(this.handleKeyUp);
    this.fields = props.fields;
    this.initialMetadata = props.initialMetadata;
    // this.isFormLocked = this.initialMetadata != null;
    this.isLocked = props.isLocked;
    this.setLockedStatus();

    this.docType = props.selected;
    this.strings = props.strings;
    if (this.docType != "" && props.types.length > 0) this.docType = props.types[0].props.children; //FIX THIS!
  }

  setLockedStatus = () => {
    if (this.props.initialMetadata != null) {
      this.hasInitialMetadata = true;
      this.isFormLocked = this.props.isLocked ?? true;
    } else {
      this.hasInitialMetadata = false;
      this.isFormLocked = false;
    }
  }

  handleChange(v) {
    this.docType = v;
    this.props.changeDocumentType(v);
  }

  getValueById = (id) => {
    const e = document.getElementById(id);
    return e && e.value ? e.value : null;;
  }

  getMetadata = () => {
    if (this.docType == null) {
      alert("Ingen dokumenttyp vald!");
      return null;
    }
    let json = '{"type":"' + this.props.selected + '"';
    for (var i = 0; i < this.props.fields.length; i++) {
      const field = this.props.fields[i];
      let value = this.getValueById(field['name']);
      const datatype = field['type'];
      if (value && value.length > 0) {
        if (datatype == 'number' || datatype == 'boolean') {
          if (datatype == 'boolean') {
            value = value === 'true';
          }
          json += ',"' + field['name'] + '":' + value;
        }
        else
          json += ',"' + field['name'] + '":"' + value + '"';
      }
    }
    json += '}';
    console.log(json)
    return json;
  }

  getFieldsForLockedForm = () => {
    const a = [];
    for (const key in this.initialMetadata) {
      const val = this.initialMetadata[key];
      if (val && 'name' in val) {
        a.push(val);
      }
    }
    a.push({ 'displayname': 'Creator', 'displayname_sv': 'Skapare' });
    a.push({ 'displayname': 'Created at', 'displayname_sv': 'Skapat' });
    a.push({ 'displayname': 'Version', 'displayname_sv': 'Version' });
    a.push({ 'displayname': 'File name', 'displayname_sv': 'Filnamn' });
    a.push({ 'displayname': 'Mimetype', 'displayname_sv': 'Mimetype' });
    return a;
  }

  getDocId = () => {
    return (this.initialMetadata && 'id' in this.initialMetadata) ? this.initialMetadata['id'].value : null;
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const targetArray = Array.from(e.target);
    const updatedValues = targetArray.map(item => ({ attr: item.name, value: item.value }));
    const initialMetadata = this.props.initialMetadata;
    const filtered = updatedValues.filter(item => item.attr in initialMetadata && initialMetadata[item.attr].value !== item.value);
    let mappedFiltered = filtered.map(item => ({attr: initialMetadata[item.attr].name, value: item.value}));
    mappedFiltered = mappedFiltered.filter(item => item.attr); 
    try {
      await this.httpClient.updateMetadata(initialMetadata.id.value, mappedFiltered, () => {
        alert(this.props.strings['MetadataUpdated']);
      });
    } catch (error) {
      console.error('Error updating metadata:', error);
      const errorMessage = error?.response?.data?.message || this.props.strings['MetadataUpdateFailed'] || 'Failed to update metadata. Please try again.';
      alert(errorMessage);
    }
  }

  getForm = () => {
    this.setLockedStatus();
    const fields =
      this.isFormLocked ? this.getFieldsForLockedForm()
        : this.hasInitialMetadata ? Object.keys(this.props.initialMetadata).filter(key => !key.startsWith("_")).map((key, index) => {
          const val = this.props.initialMetadata[key];
          return { name: key, displayname: val.displayname ?? key, displayname_sv: val.displayname_sv ?? key, value: val.value, type: val.type ?? 'text', update: val.update };
        })
          : this.props.fields;
    const formFields = 
     fields.map((item, index) => {
      item.isLocked = this.isLocked;
      const tempItem = { ...item, id: `${index}` };
      return this.field.getForm(tempItem, false, this.props.initialMetadata, this.hasInitialMetadata, this.isFormLocked);
    });
    if (this.hasInitialMetadata && !this.isFormLocked) {
      formFields.push(<Button key="submit" type="submit" className={style.button}>{this.props.strings['Submit']}</Button>);
    }
    return formFields;
  }

  getHeader = () => {
    if (this.hasInitialMetadata) return this.getLockedHeader();
    else return this.getOpenHeader();
  }


  getOpenHeader = () => {
    return (
      <FormGroup className={style.formGroup}>
        <h4 className={style.title}>{this.props.strings['MetadataForTheDocuments']}</h4>
        <hr className={style.divider} />
        <Label className={style.label} for="documentTypes">{this.props.strings['Documenttypes']}</Label>
        <Input type="select"
          className={style.select}
          name="select"
          id="documentTypes"
          value={this.props.selected}
          onChange={(e) => { this.handleChange(e.target.value) }}>
          {this.props.types}
        </Input>
      </FormGroup>
    )
  }

  getLockedHeader = () => {
    const typeAttr = this.props.strings['Type'];
    const value = (typeAttr in this.initialMetadata && 'value' in this.initialMetadata[typeAttr]) ?
      this.initialMetadata[typeAttr].value : "";
    return (
      <FormGroup key="1" className={style.formGroup}>
        <Label className={style.label}>{this.props.strings['Documenttype']}</Label>
        <Input type="text"
          className={style.input}
          id="dokumenttyp"
          name="Dokumenttyp"
          value={value}
        />
      </FormGroup>
    );
  }

  handleKeyUp = (e) => {
    const value = e.target.value;
    const format = e.target.getAttribute('format');
    if (value.match(format)) {
      e.target.setAttribute('class', 'is-valid form-control');
    } else {
      e.target.setAttribute('class', 'is-invalid form-control');
    }
  }

  handleFieldChange = (v) => {
    console.log("HandleFieldChange");
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit} className={style.metadataForm}>
        {this.getHeader()}
        {this.getForm()}
      </Form>
    );
  }
}